import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface VisaStatusFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  uploading?: boolean;
}

export function VisaStatusFields({
  profile,
  setProfile,
  readOnly,
  uploading
}: VisaStatusFieldsProps) {
  const visaApplicationStatus =
    profile?.visa_application_status || "not_applied";
  const laborMarketAuthStatus =
    profile?.labor_market_authorization_status || "not_required";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">Visum Status</label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Was ist der aktuelle Status deines Visums?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={visaApplicationStatus}
          onValueChange={(value) =>
            setProfile({
              ...profile!,
              visa_application_status: value as
                | "not_applied"
                | "applied"
                | "granted"
            })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Bitte auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_applied">Nicht beantragt</SelectItem>
            <SelectItem value="applied">Beantragt</SelectItem>
            <SelectItem value="granted">Erhalten</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">Arbeitsmarktzulassung</label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  Status der Arbeitsmarktzulassung für die Beschäftigung in
                  Deutschland
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly || uploading}
          value={laborMarketAuthStatus}
          onValueChange={(value) =>
            setProfile({
              ...profile!,
              labor_market_authorization_status: value as
                | "not_required"
                | "not_applied"
                | "applied"
                | "granted"
            })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Bitte auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_required">Nicht erforderlich</SelectItem>
            <SelectItem value="not_applied">Nicht beantragt</SelectItem>
            <SelectItem value="applied">Beantragt</SelectItem>
            <SelectItem value="granted">Erteilt</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
